"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = require("react");
/**
 * A useEffect based hook that dispatches a CustomEvent
 * of type `eventType`, on the global window object, with
 * the `detail` payload object, only on the first mount
 * of the target component.
 *
 * @param  {String} eventType - event name to listen to
 * @param {Object} detail - event payload
 * @returns {React.Ref} React reference to be attached to target
 * the target component.
 *
 * @example
 *
 * const Emitter = ({ eventData }) => {
 *   const emitterRef = useWindowDispatchOnLoad('help-portal-loaded', eventData);
 *   return <span ref={emitterRef} />;
 * }
 *
 */
var useWindowDispatchOnLoad = function useWindowDispatchOnLoad(eventType, detail) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    containerEventDispatched = _useState2[0],
    setDispatched = _useState2[1];
  var containerRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var _eventType$trim;
    if (containerRef !== null && containerRef !== void 0 && containerRef.current && !containerEventDispatched && eventType !== null && eventType !== void 0 && (_eventType$trim = (0, _trim["default"])(eventType)) !== null && _eventType$trim !== void 0 && _eventType$trim.call(eventType)) {
      (0, _setTimeout2["default"])(function () {
        if (containerRef !== null && containerRef !== void 0 && containerRef.current) {
          window.dispatchEvent(new CustomEvent(eventType, {
            detail: detail
          }));
        }
      }, 0);
      setDispatched(true);
    }
  });
  return containerRef;
};
var _default = exports["default"] = useWindowDispatchOnLoad;